import { StorageElementDepth } from "../Elements/StorageElementDepth";
import { StorageElementHeight } from "../Elements/StorageElementHeight";
import { StorageElementType } from "../Elements/StorageElementType";
import { IFilter } from "../Tools/IFilter";
import { FilterGroup } from "../Tools/FilterGroup";
import { FiltersController } from "../Tools/FiltersController";
import { Options } from "select2";
import { checkAndDestroySelect2, globalMatcher, globalTemplateResult } from "../Tools/GlobalMethods";

export class StorageTypeFilter implements IFilter {
    id: string;
    name?: string | null | undefined;
    type: string;

    controller: FiltersController;
    parentGroup: FilterGroup;
    storageElementsDepth: StorageElementDepth[];
    storageElementsHeight: StorageElementHeight[];
    storageElementsType: StorageElementType[];

    constructor(parentGroup: FilterGroup,
        storageElementsDepth: StorageElementDepth[], storageElementsHeight: StorageElementHeight[],
        storageElementsType: StorageElementType[]) {

        this.storageElementsType = storageElementsType;
        this.storageElementsHeight = storageElementsHeight;
        this.storageElementsDepth = storageElementsDepth;
        this.parentGroup = parentGroup;

        this.controller = new FiltersController();
        this.id = 'storageType';
        this.name = 'Caractéristiques des rangements';
        this.type = 'storageType';

    }

    inputStyle = 'max-width: 200px;width: 100%';

    storageDepthHtml(): string {
        let html = `
            <select id="storageDepthInput" title="${this.name}" style="${this.inputStyle}"></select>
        `;

        setTimeout(() => {
            if (this.parentGroup.isDestroyed) return;
            checkAndDestroySelect2('#storageDepthInput');
            const data = this.storageElementsDepth.map((element) => ({
                id: element.name || '-1',
                text: element.name,
                title: this.name,
                selected: element.name === FilterGroup.filters.storageElementDepth?.name
            }));

            $('#storageDepthInput').select2({
                data: data,
                width: 'element',
                selectionCssClass: 'select-control',
                matcher: globalMatcher,
                templateResult: globalTemplateResult,
            } as Options);

            $('#storageDepthInput').on('change.select2', () => {
                let selectedValue = $('#storageDepthInput').val() as string;
                if (selectedValue === '-1') {
                    FilterGroup.filters.storageElementDepth = null;
                } else {
                    FilterGroup.filters.storageElementDepth = this.storageElementsDepth.find((element) => element.name === selectedValue) || null;
                }
                FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters);
            });

        }, 50);

        return html;
    }

    storageHeightHtml(): string {
        let html = `
        <select id="storageHeightInput" title="${this.name}" style="${this.inputStyle}"></select>
        `;

        setTimeout(() => {
            if (this.parentGroup.isDestroyed) return;
            checkAndDestroySelect2('#storageHeightInput');
            const data = this.storageElementsHeight.map((element) => ({
                id: element.name || '-1',
                text: element.name,
                title: this.name,
                selected: element.name === FilterGroup.filters.storageElementHeight?.name
            }));

            $('#storageHeightInput').select2({
                data: data,
                width: 'element',
                selectionCssClass: 'select-control',
                matcher: globalMatcher,
                templateResult: globalTemplateResult,
            } as Options);

            $('#storageHeightInput').on('change.select2', () => {
                let selectedValue = $('#storageHeightInput').val() as string;
                if (selectedValue === "") {
                    FilterGroup.filters.storageElementHeight = null;
                } else {
                    FilterGroup.filters.storageElementHeight = this.storageElementsHeight.find((element) => element.name === selectedValue) || null;
                }
                FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters);
            });

        }, 50);

        return html;
    }

    storageTypeHtml(): string {
        let html = `
        <select id="storageTypeInput" title="${this.name}" style="${this.inputStyle}"></select>
        `;

        setTimeout(() => {
            if (this.parentGroup.isDestroyed) return;
            checkAndDestroySelect2('#storageTypeInput');
            const data = this.storageElementsType.map((element) => ({
                id: element.type || '-1',
                text: element.name,
                title: this.name,
                selected: element.name === FilterGroup.filters.storageElementType?.name
            }));

            $('#storageTypeInput').select2({
                data: data,
                width: 'element',
                selectionCssClass: 'select-control',
                matcher: globalMatcher,
                templateResult: globalTemplateResult,
            } as Options);

            $('#storageTypeInput').on('change.select2', () => {
                let selectedValue = $('#storageTypeInput').val() as string;
                if (selectedValue === '-1') {
                    FilterGroup.filters.storageElementType = null;
                } else {
                    FilterGroup.filters.storageElementType = this.storageElementsType.find((element) => element.type === selectedValue) || null;
                }
                FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters);
            });

        }, 50);

        return html;
    }

    html(): string {
        let html = `
    <div class="filter" style="display: flex;flex-direction: column;align-items: center;margin:0 auto;width: 100%;">
        <span>${this.name}</span>
        <div style="display: flex;align-items: center;width:100%; max-width:410px; justify-content: space-around;flex-wrap: wrap;">
            ${this.storageDepthHtml()}
            ${this.storageHeightHtml()}
            ${this.storageTypeHtml()}
        </div>
    </div>
    `;

        return html;
    }

    destroy(): void {
        $('#storageDepthInput').off('change.select2');
        $('#storageHeightInput').off('change.select2');
        $('#storageTypeInput').off('change.select2');
        checkAndDestroySelect2('storageDepthInput');
        checkAndDestroySelect2('storageHeightInput');
        checkAndDestroySelect2('storageTypeInput');
        this.controller.destroy();
    }
}